// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import React, { ReactElement, ReactNode } from 'react';
import { Item } from './Item';

import './THMenu.scss';

interface THMenuProps {
    children: ReactNode;
    className?: string;
    onClick?: () => void;
}

export const THMenu = ({ children, className, onClick }: THMenuProps): ReactElement => (
    <div className={classList('th-menu', className)} onClick={onClick}>
        {children}
    </div>
);

THMenu.Item = Item;
